import { Sun, Moon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDarkMode } from '../../hooks/useDarkMode';
import { motion } from 'framer-motion';

export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, setTheme } = useDarkMode();

  const themes = [
    { value: 'light' as const, icon: Sun, label: t('header.light') },
    { value: 'dark' as const, icon: Moon, label: t('header.dark') },
  ];

  return (
    <div className="flex items-center space-x-0.5 sm:space-x-1.5 bg-transparent rounded-lg p-0.5 sm:p-1.5">
      {themes.map(({ value, icon: Icon, label }) => (
        <motion.button
          key={value}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setTheme(value)}
          className={`
            relative px-2 py-1.5 sm:px-4 sm:py-2 rounded-lg text-sm font-medium transition-all duration-200
            ${theme === value 
              ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm' 
              : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700'
            }
          `}
          title={label}
        >
          <Icon size={16} className="sm:w-5 sm:h-5" />
        </motion.button>
      ))}
    </div>
  );
}
